import React, { PropsWithChildren } from 'react';
import componentProps, { ComponentProps } from '../../../../../helpers/componentProps';
import { applyComponentTheme } from '../../../../../theme';
import { LabelWrapper, StyledLabel } from '../Label/styles';

const Legend: React.FC<PropsWithChildren<ComponentProps>> = ({ children, ...rest }) => (
  <LabelWrapper {...componentProps(rest)}>
    <StyledLabel as="legend">{children}</StyledLabel>
  </LabelWrapper>
);

export default applyComponentTheme(Legend, 'Legend');
